import { useState } from 'react';
import { Card, Space, Button } from 'antd';
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import InputNumber from "components/input-number";
import { formatCurrency } from "utils/number";
import { useOrderEditContext } from '../OrderEditContext';

const OrderLineItemsCardDesktop = () => {
    const { lineItems, onLineQuantityChange, onLinePriceChange, setLineItemPriceType } = useOrderEditContext();
    const [activeRemoveId, setActiveRemoveId] = useState(null);

    const resetActiveRemove = () => setActiveRemoveId(null);

    const showRemoveButton = (productId) => activeRemoveId === productId;

    const onRemoveLine = (event, productId) => {
        event.stopPropagation();
        onLineQuantityChange(productId, 0);
        setActiveRemoveId(null);
    };

    const renderPriceCell = (line) => {
        if (line.price_type === "2") {
            return (
                <Space>
                    <InputNumber value={line.price} onChange={value => onLinePriceChange(line.product_id, value)}></InputNumber>
                </Space>
            );
        }

        return (
            <Space>
                {formatCurrency(line.price)}
                <Button type='text' onClick={() => setLineItemPriceType(line.product_id, "2")}><EditOutlined /></Button>
            </Space>
        );
    };

    return (
        <Card onClick={resetActiveRemove}>
            <table className='tbl_order' style={{ width: "100%" }}>
                <thead>
                    <tr>
                        <th>
                            <Space>
                                Sản phẩm
                            </Space>
                        </th>
                        <th>Số lượng</th>
                        <th>Đơn giá</th>
                        <th>Thành tiền</th>
                    </tr>
                </thead>

                <tbody className='ant-table-tbody'>
                    {lineItems.map(line => (
                        <tr key={line.product_id}>
                            <td>
                                {line.product?.name} {line.variant?.variant_title}
                            </td>
                            <td onClick={e => e.stopPropagation()}>
                                <Space onClick={() => setActiveRemoveId(line.product_id)}>
                                    <InputNumber value={line.quantity} showCalculator={false} onChange={value => onLineQuantityChange(line.product_id, value)}></InputNumber>
                                    {showRemoveButton(line.product_id) && (
                                        <Button
                                            type='text'
                                            danger
                                            icon={<CloseOutlined />}
                                            onClick={e => onRemoveLine(e, line.product_id)}
                                        />
                                    )}
                                </Space>
                            </td>
                            <td style={{ textAlign: "right" }}>
                                {renderPriceCell(line)}
                            </td>
                            <td style={{ textAlign: "right" }}>
                                {formatCurrency(line.amount)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Card>
    );
};

export default OrderLineItemsCardDesktop;
